<template>
  <div
    id="bottom-progress-bar"
    class="bottom-slide-progress-bar"
  >
    <div
      class="slide-progress-bar"
      :style="{
        width: percentProgress
      }"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      slides: (state) => state.slides,
    }),
    ...mapGetters({
      activeSlide: 'activeActivity',
    }),
    percentProgress() {
      const index = this.slides.findIndex((item) => {
        return item.id == this.activeSlide.id
      })
      if (index !== -1 && this.slides.length) {
        return `${((index + 1) * 100) / this.slides.length}%`
      }
      return `${0}%`
    },
  },
  watch: {
    'slide.id': {
      handler() {
        this.getDataProgress()
      },
      immediate: true,
    },
  },
  mounted() {
    this.getSlideList()
  },
  methods: {
    ...mapActions(['getSlidesAction', 'setSlideIndexAction']),
    getDataProgress() {
      if (!this.activeSlide.id && !this.slides.length) return

      const index = this.slides.findIndex((item) => {
        return item.id == this.activeSlide.id
      })

      if (index != -1) {
        this.setSlideIndexAction({
          index,
        })
      }
    },
    async getSlideList() {
      try {
        await this.getSlidesAction()

        this.getDataProgress()
      } catch (error) {
        if (Sentry && error.status) {
          Sentry.captureException(JSON.stringify(error))
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.bottom-slide-progress-bar {
  height: 4px;
  width: 100%;
  background-color: #D3D7E1;

  .slide-progress-bar {
    background-color: #313131;
    height: 100%;
    transition: width 0.5s;
  }
}
</style>
